import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/vgt";

export const StickyBar = () => (
  <header
    data-testid="sticky-bar"
    className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#FDFBF7]/90 border-b border-[#E6DEC3]/70"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-center justify-between gap-4">
      <a
        href="/indonesian-vanilla-supplier"
        data-testid="brand-logo-link"
        className="flex items-center gap-3 min-w-0"
      >
        <img
          src="/images/vgt-logo.jpg"
          alt="Vanilla Global Transindo logo"
          className="w-11 h-11 rounded-full object-cover shrink-0 ring-1 ring-[#E6DEC3] shadow-sm"
        />
        <span className="leading-tight min-w-0">
          <span className="block font-serif font-bold text-[#2C1A0C] text-sm sm:text-base truncate">
            Vanilla Global Transindo
          </span>
          <span className="block font-mono text-[10px] tracking-[0.22em] uppercase text-[#6E5B4F]">
            Indonesian Vanilla Exporter
          </span>
        </span>
      </a>
      <button
        data-testid="sticky-cta-quote-button"
        onClick={() => scrollToId("quotation")}
        className="group shrink-0 inline-flex items-center gap-2 bg-[#2E4F3E] hover:bg-[#1B3B2B] text-[#FDFBF7] text-sm font-semibold rounded-full px-4 sm:px-6 py-2.5 transition-colors duration-300"
      >
        Request a Quotation
        <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5" />
      </button>
    </div>
  </header>
);
